import { render, staticRenderFns } from "./AddConfigSetting.vue?vue&type=template&id=0c92ca37&"
import script from "./AddConfigSetting.vue?vue&type=script&lang=js&"
export * from "./AddConfigSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports